<div class="ranking-table__main">
  <div class="loading" *ngIf="loading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  <!-- No Data Message -->
  <div class="nodata" *ngIf="noData && !loading">NO DATA AVAILABLE</div>

  <ng-container *ngIf="!loading && !noData">
    <div class="ranking-table__titolo">
      <div class="ranking-table__box-trend">
        <div class="tito">
          <span class="ranking-table__box-trend-column">Entity </span>
        </div>
        <div class="info">
          <span class="ranking-table__box-trend-column"
            >{{ getRankingScoreTitle(childRankingScoreType) }}
          </span>
        </div>
      </div>
    </div>
    <div class="ranking-table__body">
      <div
        class="ranking-table__row"
        *ngFor="let data of rankingTableData; let i = index"
      >
        <div class="ranking-table__box-trend">
          <div class="tito">
            <div class="cont">
              <span class="value">{{ data.name }}</span>
            </div>
          </div>
          <div class="info">
            <div class="cont">
              <span
                class="value"
                [style.color]="getScoreColor(data)"
                *ngIf="data.scoreType !== 'sentiment'"
                >{{ data.score }}</span
              >
              <span
                class="value"
                [style.color]="getScoreColor(data)"
                *ngIf="data.scoreType === 'sentiment'"
                >{{ data.score | percent }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
